import React, { useState } from 'react';
import '../css/TaxSavingsQuiz.css';

const questions = [
  {
    question: 'About how much do you currently have invested in taxable brokerage accounts?',
    options: ['Less than $10,000', '$10,000 – $50,000', '$50,000 – $200,000', 'Over $200,000'],
    scores: [10, 20, 30, 40],
  },
  {
    question: 'How many trades have you made in 2024 so far?',
    options: ['Fewer than 5', '5–20', '20–50', 'More than 50'],
    scores: [5, 10, 15, 20],
  },
  {
    question: 'Have you sold any investments at a loss this year?',
    options: ['Yes', 'No', 'Not sure'],
    scores: [10, 0, 5],
  },
  {
    question: 'After selling at a loss, have you re-bought the same stock within 30 days?',
    options: ['Yes', 'No', 'Not sure'],
    scores: [0, 10, 5],
  },
  {
    question: 'Do you typically sell investments held for less than a year?',
    options: ['Yes, often', 'Sometimes', 'Rarely or never'],
    scores: [0, 5, 10],
  },
  {
    question: 'Are you using any tax tool or advisor to optimize taxes?',
    options: ['Yes', 'No', 'I don\'t do anything tax-specific'],
    scores: [10, 5, 0],
  }
];

const personalizedAdvice = (answers) => {
  const tips = [];

  if (answers[1] >= 2) {
    tips.push('📊 As an active trader, automated tax-loss harvesting tools like ProfiTree can help optimize your strategy daily.');
  }

  if (answers[2] === 1 || answers[2] === 2) {
    tips.push('📉 Consider tracking unrealized losses systematically - ProfiTree can help identify these opportunities automatically.');
  }

  if (answers[3] === 0) {
    tips.push('🚫 Be cautious of wash sales - smart tools can help track your 30-day replacement windows to avoid costly mistakes.');
  }

  if (answers[4] === 0 || answers[4] === 1) {
    tips.push('🕒 Consider extending holding periods beyond one year to benefit from lower long-term capital gains rates. ProfiTree can help optimize your holding strategy.');
  }

  if (answers[5] === 1 || answers[5] === 2) {
    tips.push('💡 Enhance your tax strategy with ProfiTree\'s AI-powered optimization tools - start saving on taxes today.');
  }

  return tips;
};

const TaxSavingsQuiz = () => {
  const [step, setStep] = useState(0);
  const [score, setScore] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [previousScores, setPreviousScores] = useState([]);
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleAnswer = (index) => {
    const answerScore = questions[step].scores[index];
    setScore(prev => prev + answerScore);
    setPreviousScores(prev => [...prev, answerScore]);
    setAnswers(prev => [...prev, index]);
    setStep(prev => prev + 1);
  };

  const handleBack = () => {
    if (step > 0) {
      const lastScore = previousScores[previousScores.length - 1];
      setScore(prev => prev - lastScore);
      setPreviousScores(prev => prev.slice(0, -1));
      setAnswers(prev => prev.slice(0, -1));
      setStep(prev => prev - 1);
    }
  };

  const handleEmailSubmit = (e) => {
    e.preventDefault();
    console.log('Email submitted:', email);
    setSubmitted(true);
  };

  if (step >= questions.length) {
    const advice = personalizedAdvice(answers);

    return (
      <div className="quiz-results">
        <h2>Your Tax-Saving Score: {score}/100</h2>
        <p>Here's how you can get smarter about taxes based on your answers:</p>
        <ul className="summary-list">
          {advice.map((tip, idx) => {
            const icon = tip.split(' ')[0];
            const text = tip.slice(2);
            return (
              <li key={idx} data-icon={icon}>
                {text}
              </li>
            );
          })}
        </ul>
        {submitted ? (
          <div className="success-msg">
            Thanks! You're all set to receive expert tips and alerts.
          </div>
        ) : (
          <form onSubmit={handleEmailSubmit} className="email-form">
            <label htmlFor="email">Stay up-to-date with smarter investing tips & tax hacks:</label>
            <input
              type="email"
              required
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
            />
            <button type="submit">Subscribe</button>
          </form>
        )}
      </div>
    );
  }

  const { question, options } = questions[step];

  return (
    <div className="quiz-container">
      <h2>{question}</h2>
      <div className="options">
        {options.map((option, idx) => (
          <button
            key={idx}
            onClick={() => handleAnswer(idx)}
          >
            {option}
          </button>
        ))}
      </div>
      <div style={{ textAlign: 'center', marginTop: '2rem' }}>
        <span style={{ 
          background: '#f8f9fa',
          padding: '8px 16px',
          borderRadius: '20px',
          color: '#666',
          fontSize: '14px',
          display: 'inline-block',
          marginBottom: '1rem'
        }}>
          Question {step + 1} of {questions.length}
        </span>
        {step > 0 && (
          <button className="back-button" onClick={handleBack}>
            ← Back
          </button>
        )}
      </div>
    </div>
  );
};

export default TaxSavingsQuiz;
